import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteContractor } from '../../../../actions';

const ContractorDeleteButton = ({
  dispatchDeleteContractor,
  contractorId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteContractor({ contractorId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

ContractorDeleteButton.propTypes = {
  dispatchDeleteContractor: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  contractorId: PropTypes.number.isRequired,
};

ContractorDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteContractor: deleteContractor,
};

export default connect(null, mapDispatchToProps)(ContractorDeleteButton);
